import { MessageSource } from 'widget/types/common';
import { WidgetEvents } from 'widget/types/events';

export const postMessageToParent = (
  event: WidgetEvents,
  payload?: unknown
): void => {
  if (!window.parent || window.parent === window) {
    return;
  }

  window.parent.postMessage(
    {
      source: MessageSource.WIDGET,
      event,
      payload
    },
    '*'
  );
};
